import { AutogenModelServiceIncidentPostHist, AutogenRowServiceIncidentPostHist } from "./autogen/AutogenModelServiceIncidentPostHist";

export class ModelServiceIncidentPostHist extends AutogenModelServiceIncidentPostHist<RowServiceIncidentPostHist> {
	constructor() {
		super(RowServiceIncidentPostHist);
	}
}

export class RowServiceIncidentPostHist extends AutogenRowServiceIncidentPostHist {
}